// extracted by mini-css-extract-plugin
export default {"BrokerWiseBrokerLogo":"BrokerWiseBrokerLogo_BrokerWiseBrokerLogo__03YND","separator":"BrokerWiseBrokerLogo_separator__cDDBo"};